<template>
  <div>
    <div class="frankinForm__stepThree step">
      <div class="in container">
        <section class="formIntro">
          <div class="in container">
            <h4>Step 3 of 3 - Your current agreement</h4>
            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question" style="margin:0">
                <label style="font-weight:500">
                  For this section you will need:
                  <ul>
                    <li v-if="step1.franking_contract == 'yes'">
                      - A copy of a recent lease agreement
                    </li>
                    <li>
                      - A copy of your last service invoice
                    </li>
                    <li>
                      - A copy of your originally signed agreements
                    </li>
                  </ul>
                </label>
                <div style="margin-top:20px;margin-top: 20px;font-size: 1.4rem;line-height: 1.4;margin-bottom: 2.125rem;color: #363636;">
                  Don’t worry if you don’t have this information we can still support you, chat with us or click here for more info.
                </div>
                <div style="margin-top:20px;margin-top: 20px;font-size: 1.4rem;line-height: 1.4;margin-bottom: 2.125rem;color: #363636;" v-if="step1.franking_contract == 'yes'">
                  If you are still in contract we will look to source a quote which includes paying off your current agreement so your business can benefit from savings and new technology now without waiting
                </div>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
                <div class="box box--text" onclick="" style="width:100%; cursor:pointer;" @click="() => { $refs.clickItem1.click() }">
                  What do I do if I don't have this information?
                </div>
              </div>
              <div class="inputPanel__col inputPanel__info">
                <div class="infoIcon" data-tip="Info here" ref="clickItem1">
                  i
                </div>
              </div>
              <info-modal>
                <span style="color: #fff;margin-bottom: 20px;display: block">If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
                <br>
                The below graphic shows typical invoices with the key information highlighted;
                Rental costs circled in Green,
                Maintenance/Service Costs circled in Orange,
                ValueMax/Insurance waiver fees in Red,
                Invoice Fees circled in Blue
                <br>
                The payment frequency is circled in Purple
                <br>
                **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**</span>
                <img src="/static/styles/mailkit/img/lease-information-pop-up.png" alt="" style="width: 100%;">
              </info-modal>
            </div>
          </div>
        </section>

        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.annual_maintenance_package_cost }" v-if="step1.franking_contract == 'no_purchased'">
          <div class="inputPanel__col inputPanel__question">
            <label>What do you currently pay for annual maintenance package and royal mail rate updates?</label>
            <div class="inputPanel__col inputPanel__info">
              <div class="infoIcon" data-tip="Info here">
                i
              </div>
            </div>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
            <input type="text" class="inputReg" name="payforannualmaintenance" id="payforannualmaintenance" placeholder="Enter Value" v-model="annual_maintenance_package_cost" v-positive-numbers-only/>
            <error-modal>
              The best place to locate this information is your last service invoice and if you are charged for rate up dates please add this charge to the annual service cost you pay. Rate charges are often applied around March/April each year where your service cover does not include this provision.
              <br>
              **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
            </error-modal>
          </div>
          <info-modal>
            The best place to locate this information is your last service invoice and if you are charged for rate up dates please add this charge to the annual service cost you pay. Rate charges are often applied around March/April each year where your service cover does not include this provision.
            <br>
            **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
            <img src="/static/styles/mailkit/img/service-information-pop-up.png" alt="" style="width: 100%;">
          </info-modal>
        </div>
        <div v-if="step1.franking_contract != 'no_purchased'">
          <div class="agreement">
            <h4 style="font-size: 1.8rem;margin-bottom: 10px;line-height: 1.2em;color: #0a70e3;">Your agreement start and end dates</h4>
          </div>
          <div class="frankinForm__dateBlock" :class="{'inputPanel__error' : invalidFields.lease_end_month || invalidFields.lease_end_year || invalidFields.lease_start_month || invalidFields.lease_start_year }">
            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question inputPanel__question--right">
                <label>When did your lease start?</label>
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
                <info-modal>
                  To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.
                  <br>
                  The below graphic shows typical agreements with the key information highlighted;
                  The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.
                  <br>
                  If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.
                  <br>
                  To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.
                  <br>
                  **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                  <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
                </info-modal>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--inlineTwo">
                <div class="smallSelect">
                  <select name="leasestartone" v-model="lease_start_month">
                    <option disabled selected :value="null">Month</option>
                    <option v-for="month, name in numberedDropdown(1,12, false, true)" :value="month">{{ name }}</option>
                  </select>
                </div>
                <div class="smallSelect">
                  <select name="leasestarttwo" v-model="lease_start_year">
                    <option disabled selected :value="null">Year</option>
                    <option v-for="year in numberedDropdown(minYears, maxYears, true)" :value="year">{{ year }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question inputPanel__question--right">
                <label>When does your agreement end?</label>
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
                <info-modal>
                  To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.
                  <br>
                  The below graphic shows typical agreements with the key information highlighted;
                  The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.
                  <br>
                  If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.
                  <br>
                  To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.
                  <br>
                  **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                  <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
                </info-modal>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--inlineTwo">
                <div class="smallSelect">
                  <select name="agreementendone" v-model="lease_end_month">
                    <option disabled selected :value="null">Month</option>
                    <option :value="0">I don't know</option>
                    <option v-for="month, name in numberedDropdown(1,12, false, true)" :value="month">{{ name }}</option>
                  </select>
                </div>
                <div class="smallSelect">
                  <select name="agreementendtwo" v-model="lease_end_year">
                    <option disabled selected :value="null">Year</option>
                    <option :value="0">I don't know</option>
                    <option v-for="year in numberedDropdown(minYears + 7, maxYears + 8, true)" :value="year">{{ year }}</option>
                  </select>
                </div>
              </div>
            </div>
            <error-modal>
              To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.
              <br>
              The below graphic shows typical agreements with the key information highlighted;
              The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.
              <br>
              If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.
              <br>
              To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.
              <br>
              **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
              <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
            </error-modal>
          </div>
          <div class="frankinForm__dateBlock" :class="{'inputPanel__error' : invalidFields.lease_billing_period || invalidFields.lease_payments_made }" v-if="lease_end_month === 0 || lease_end_year === 0">
            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question">

              </div>
            </div>
            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question inputPanel__question--right">
                <label>What is your current agreement term (Months, Quarters or Years)?</label>
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--inlineTwo">
                <div class="smallSelect">
                  <select name="currentagreementtermone" v-model="lease_billing_period">
                    <option disabled selected :value="null">Billing Period</option>
                    <option v-for="title, period in billingPeriods" :value="period">{{ title }}</option>
                  </select>
                </div>
                <div class="smallSelect">
                  <select name="currentagreementtermtwo" v-model="lease_payments_made">
                    <option disabled selected :value="null">Payments</option>
                    <option v-for="number in numberedDropdown(1,getLeaseMaxNumber(), false, false)" :value="number">{{ number }}</option>
                  </select>
                </div>
              </div>
              <info-modal>
                To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.
                <br>
                The below graphic shows typical agreements with the key information highlighted;
                The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.
                <br>
                If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.
                <br>
                To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.
                <br>
                **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
              </info-modal>
            </div>
            <error-modal>
              To help you find the relevant information from your existing agreement we have provided below some lease agreement examples to help you locate the required information.
              <br>
              The below graphic shows typical agreements with the key information highlighted;
              The start date isn’t necessarily the date the agreement was signed, this is actually normally the accepted or dispatched date. Please use the accepted or dispatched date where you have this information. In our examples this is circled in Green.
              <br>
              If this isn’t noted please use the contract signed date, in these examples this is circled in Orange.
              <br>
              To help you locate the key information regarding the term i.e. duration and payment frequency we have highlighted these areas by circling in Purple.
              <br>
              **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
              <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
            </error-modal>
          </div>
          <div class="frankinForm__dateBlock" :class="{'inputPanel__error' : invalidFields.lease_cost || invalidFields.lease_frequency }">


            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question inputPanel__question--right">
                <label>Current rental/lease (excluding service)?</label>
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
                <info-modal>
                  If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
                  <br>
                  The below graphic shows typical invoices with the key information highlighted;
                  Rental costs circled in Green,
                  Maintenance/Service Costs circled in Orange,
                  ValueMax/Insurance waiver fees in Red,
                  Invoice Fees circled in Blue
                  <br>
                  The payment frequency is circled in Purple
                  <br>
                  **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                  <img src="/static/styles/mailkit/img/lease-information-pop-up.png" alt="" style="width: 100%;">
                </info-modal>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--inlineTwo">
                <div>
                  <input id="leaseCostStep3" type="number" placeholder="Enter Cost" class="inputReg" v-model="lease_cost" v-positive-numbers-only>
                </div>
                <div class="smallSelect">
                  <select name="currentservicecosttwo" v-model="lease_frequency">
                    <option disabled selected :value="null">Frequency</option>
                    <option v-for="title, period in billingPeriods" :value="period">{{ title }}</option>
                  </select>
                </div>
              </div>
            </div>
            <error-modal>
              If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
              <br>
              The below graphic shows typical invoices with the key information highlighted;
              Rental costs circled in Green,
              Maintenance/Service Costs circled in Orange,
              ValueMax/Insurance waiver fees in Red,
              Invoice Fees circled in Blue
              <br>
              The payment frequency is circled in Purple
              <br>
              **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
              <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
            </error-modal>
          </div>
          <div class="frankinForm__dateBlock" :class="{'inputPanel__error' : invalidFields.service_cost || invalidFields.service_frequency }">

            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question inputPanel__question--right">
                <label>Current service cost?</label>
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
                <info-modal>
                  If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
                  <br>
                  The below graphic shows typical invoices with the key information highlighted;
                  Rental costs circled in Green,
                  Maintenance/Service Costs circled in Orange,
                  ValueMax/Insurance waiver fees in Red,
                  Invoice Fees circled in Blue
                  <br>
                  The payment frequency is circled in Purple
                  <br>
                  **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                  <img src="/static/styles/mailkit/img/lease-information-pop-up.png" alt="" style="width: 100%;">
                </info-modal>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--inlineTwo">
                <div>
                  <input id="serviceCostStep3" type="number" placeholder="Enter Cost" class="inputReg" v-model="service_cost" v-positive-numbers-only>
                </div>
                <div class="smallSelect">
                  <select name="stuffstuff" v-model="service_frequency">
                    <option disabled selected :value="null">Frequency</option>
                    <option v-for="title, period in billingPeriods" :value="period">{{ title }}</option>
                  </select>
                </div>
              </div>
            </div>
            <error-modal>
              If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
              <br>
              The below graphic shows typical invoices with the key information highlighted;
              Rental costs circled in Green,
              Maintenance/Service Costs circled in Orange,
              ValueMax/Insurance waiver fees in Red,
              Invoice Fees circled in Blue
              <br>
              The payment frequency is circled in Purple
              <br>
              **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
            </error-modal>
          </div>
          <div class="frankinForm__dateBlock" :class="{'inputPanel__error' : invalidFields.invoice_fee_cost || invalidFields.invoice_fee_frequency }">

            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question inputPanel__question--right">
                <label>Do you pay any invoice fees (check lease invoice and confirm cost)?</label>
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
                <info-modal>
                  If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
                  <br>
                  The below graphic shows typical invoices with the key information highlighted;
                  Rental costs circled in Green,
                  Maintenance/Service Costs circled in Orange,
                  ValueMax/Insurance waiver fees in Red,
                  Invoice Fees circled in Blue
                  <br>
                  The payment frequency is circled in Purple
                  <br>
                  **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                  <img src="/static/styles/mailkit/img/lease-information-pop-up.png" alt="" style="width: 100%;">
                </info-modal>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--inlineTwo">
                <div class="smallSelect">
                  <div>
                    <input id="invoiceFeecostStep3" type="number" placeholder="Enter Cost" class="inputReg" v-model="invoice_fee_cost" v-positive-numbers-only>
                  </div>
                </div>
                <div class="smallSelect">
                  <select name="invoicefeestwo" v-model="invoice_fee_frequency" :class="{'active' : invoice_fee_frequency}">
                    <option disabled selected :value="null">Frequency</option>
                    <option v-for="title, period in billingPeriods" :value="period">{{ title }}</option>
                  </select>
                </div>
              </div>
            </div>
            <error-modal>
              If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
              <br>
              The below graphic shows typical invoices with the key information highlighted;
              Rental costs circled in Green,
              Maintenance/Service Costs circled in Orange,
              ValueMax/Insurance waiver fees in Red,
              Invoice Fees circled in Blue
              <br>
              The payment frequency is circled in Purple
              <br>
              **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
              <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
            </error-modal>
          </div>
          <div class="frankinForm__dateBlock" :class="{'inputPanel__error' : invalidFields.insurance_fee_cost || invalidFields.insurance_fee_frequency }">

            <div class="inputPanel">
              <div class="inputPanel__col inputPanel__question inputPanel__question--right">
                <label>Do you pay any insurance fees (check lease invoice)?</label>
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
                <info-modal>
                  If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
                  <br>
                  The below graphic shows typical invoices with the key information highlighted;
                  Rental costs circled in Green,
                  Maintenance/Service Costs circled in Orange,
                  ValueMax/Insurance waiver fees in Red,
                  Invoice Fees circled in Blue
                  <br>
                  The payment frequency is circled in Purple
                  <br>
                  **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
                  <img src="/static/styles/mailkit/img/lease-information-pop-up.png" alt="" style="width: 100%;">
                </info-modal>
              </div>
              <div class="inputPanel__col inputPanel__input inputPanel__input--inlineTwo">
                <div class="smallSelect">
                  <div>
                    <input id="insuranceFeecostStep3" type="number" placeholder="Enter Cost" class="inputReg" v-model="insurance_fee_cost" v-positive-numbers-only>
                  </div>
                </div>
                <div class="smallSelect">
                  <select name="insurancefeestwo" v-model="insurance_fee_frequency" :class="{'active' : insurance_fee_frequency}">
                    <option disabled selected :value="null">Frequency</option>
                    <option v-for="title, period in billingPeriods" :value="period">{{ title }}</option>
                  </select>
                </div>
              </div>
            </div>
            <error-modal>
              If you are not sure whether you lease or own your equipment the best way to check is to review your latest invoice. Purchased equipment will typically be invoiced for service/maintenance annually only, whereas leased/rented equipment will be invoiced, monthly, quarterly or annually and the lease/rental costs will invoice separately from the service/maintenance costs.
              <br>
              The below graphic shows typical invoices with the key information highlighted;
              Rental costs circled in Green,
              Maintenance/Service Costs circled in Orange,
              ValueMax/Insurance waiver fees in Red,
              Invoice Fees circled in Blue
              <br>
              The payment frequency is circled in Purple
              <br>
              **We offer a service to allow us to get all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to request this free service.**
              <img src="/static/styles/mailkit/img/lease-agreement-information.png" alt="" style="width: 100%;">
            </error-modal>
          </div>

          <invalid-fields v-if="invalidFields && Object.keys(invalidFields).length > 0"></invalid-fields>

        </div>

        <div class="frankinForm__saveProgress saveProgress saveProgress--full saveProgress--paddingLarge">
          <div class="in">
            <div class="saveProgress__content">
              <p>Great! You have completed all that’s required</p>
            </div>
            <div class="saveProgress__form saveProgress__form--noInputs saveProgress__form--noMarginBottom">
              <input type="submit" value="View Results" @click.prevent="updateQuote(3)" id="detailsStep3Submit" onclick="window.scrollTo(0, 0);"/>
            </div>
            <div class="inputPanel__col inputPanel__question" style="position:relative">
                <input id="inputPanelQuestionStep3" type="submit" value="< Back" @click.prevent="stepBack()" class="form-back-button" style="color:#fff;cursor:pointer;position: absolute;left: 0;bottom: 0;text-align: left;"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import InfoModal from '../InfoModal.vue'
  import ErrorModal from '../ErrorModal.vue'
  import InvalidFields from '../InvalidFieldsModal.vue'

  export default {
    components: {
      'info-modal': InfoModal,
      'error-modal': ErrorModal,
      'invalid-fields': InvalidFields,
    },
    data() {
      return {
        minYears: parseInt(moment().format('Y')) - 10,
        maxYears: parseInt(moment().format('Y')),
        billingPeriods: {
          'month': 'Monthly',
          'quarter': 'Quarterly',
          'year': 'Yearly',
        },
      }
    },
    computed: {
      ...mapState('QuoteForm', ['step2', 'step1', 'step3', 'invalidFields']),


      annual_maintenance_package_cost: {
        get() {
          return this.step3.annual_maintenance_package_cost
        },
        set(value) {
          this.updateStep3({annual_maintenance_package_cost: value})
        }
      },
      lease_start_month: {
        get() {
          return this.step3.lease_start_month
        },
        set(value) {
          this.updateStep3({lease_start_month: value})
        }
      },
      lease_end_month: {
        get() {
          return this.step3.lease_end_month
        },
        set(value) {
          this.updateStep3({lease_end_month: value})
          if (value === 0) {
            this.updateStep3({lease_end_year: 0})
            $('[name=agreementendtwo]').addClass('active')
            $('[name=agreementendone]').addClass('active')
          }
        }
      },
      lease_start_year: {
        get() {
          return this.step3.lease_start_year
        },
        set(value) {
          this.updateStep3({lease_start_year: value})
        }
      },
      lease_end_year: {
        get() {
          return this.step3.lease_end_year
        },
        set(value) {
          this.updateStep3({lease_end_year: value})
          if (value === 0) {
            this.updateStep3({lease_end_month: 0})
            $('[name=agreementendtwo]').addClass('active')
            $('[name=agreementendone]').addClass('active')
          }
        }
      },
      lease_billing_period: {
        get() {
          return this.step3.lease_billing_period
        },
        set(value) {
          this.updateStep3({
            lease_billing_period: value,
            invoice_fee_frequency: value,
            insurance_fee_frequency: value,
          })
        }
      },
      lease_payments_made: {
        get() {
          return this.step3.lease_payments_made
        },
        set(value) {
          this.updateStep3({lease_payments_made: value})
        }
      },
      lease_cost: {
        get() {
          return this.step3.lease_cost
        },
        set(value) {
          this.updateStep3({lease_cost: value})
        }
      },
      service_cost: {
        get() {
          return this.step3.service_cost
        },
        set(value) {
          this.updateStep3({service_cost: value})
        }
      },
      lease_frequency: {
        get() {
          return this.step3.lease_frequency
        },
        set(value) {
          this.updateStep3({lease_frequency: value})
        }
      },
      service_frequency: {
        get() {
          return this.step3.service_frequency
        },
        set(value) {
          this.updateStep3({service_frequency: value})
        }
      },
      invoice_fee_cost: {
        get() {
          return this.step3.invoice_fee_cost
        },
        set(value) {
          this.updateStep3({invoice_fee_cost: value})
        }
      },
      invoice_fee_frequency: {
        get() {
          return this.step3.invoice_fee_frequency
        },
        set(value) {
          this.updateStep3({invoice_fee_frequency: value})
        }
      },
      insurance_fee_cost: {
        get() {
          return this.step3.insurance_fee_cost
        },
        set(value) {
          this.updateStep3({insurance_fee_cost: value})
        }
      },
      insurance_fee_frequency: {
        get() {
          return this.step3.insurance_fee_frequency
        },
        set(value) {
          this.updateStep3({insurance_fee_frequency: value})
        }
      },


    },
    methods: {
      ...mapMutations('QuoteForm', ['updateStep3', 'stepBack']),
      ...mapActions('QuoteForm', ['updateQuote']),

      numberedDropdown(min, max, reverse = false, month = false) {
        let arr = month ? {} : []
        for (let i = min; i <= max; i++) {
          if (month) {
            arr[moment().month(i - 1).format('MMMM')] = i
          } else {
            arr.push(i)
          }
        }
        if (reverse) arr = arr.reverse()
        return arr
      },
      getLeaseMaxNumber() {
        if (this.lease_billing_period === 'month') {
          return 75
        } else if (this.lease_billing_period === 'quarter') {
          return 24
        }
        return 6
      }
    }

  }
</script>

<style scoped lang="scss">
  .inputPanel {
    .inputReg {
      height: 25px;
      font-size: 1.125rem;
    }

    .smallSelect select {
      padding: 0 .9375rem;
      height: 25px;
      background-color: #fff;
      font-size: 1.125rem;
      color: #939495;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Quotes/Form/Step-3/Form.vue